(function($) {
  jQuery(document).on( 'ready', function() {

    var breakpoint = 768;
    var bodyHeight = $('body').outerHeight();
    
    var headerHeight = 0;
    var metaBarHeight = 0;
    var headerOffset = 0;

    headerHeight = ( $('header.header').size() >= 1) ? $('header.header').outerHeight() : 0;
    metaBarHeight = ( $('.meta-bar').size() >= 1) ? $('.meta-bar').outerHeight() : 0;
    headerOffset = headerHeight + metaBarHeight;

    var tickerHeight = $('.ticker').outerHeight();




    // Layout: Safari Support
    if ( $('body').width() > breakpoint ) {
      $('.has-fullheight > .is-fullheight').css('height', 'calc(100vh - ' + headerOffset + 'px)');
      // $('.has-fullheight > .is-fullheight .tile').css('max-height', 'calc(100vh - ' + headerOffset + 'px)');
      $('.main-menu .layer').css('max-height', 'calc(100vh - ' + headerOffset + 'px)');
      $('.page-template-public-programm .has-fullheight > .is-fullheight > .tile').css('max-height', 'calc(100vh - ' + headerOffset + 'px)');
      $('.page-template-public-programm .has-fullheight > .is-fullheight > .tile > *').css('max-height', 'calc(100vh - ' + headerOffset + 'px)');
      $('.page-template-public-support .has-fullheight > .is-fullheight > .tile').css('max-height', 'calc(100vh - ' + headerOffset + 'px)');
      $('.page-template-public-support .has-fullheight > .is-fullheight > .tile > *').css('max-height', 'calc(100vh - ' + headerOffset + 'px)');
      $('.page-template-public-lounge .has-fullheight > .is-fullheight > .tile').css('max-height', 'calc(100vh - ' + headerOffset + 'px)');
      $('.page-template-public-lounge .has-fullheight > .is-fullheight > .tile > *').css('max-height', 'calc(100vh - ' + headerOffset + 'px)');
   
    } else {
      $('.has-fullheight > .is-fullheight').css('height', '100%)');
    }



    // Support Video
    if ( $('body').width() <= breakpoint ) {
      $('.page-template-public-support .is-fullheight').prepend($('.video-parent'));
    }
    

    /* Toogle Box */
    $('.block-toggle').each(function(index, el) {
      var $box = $(this);

      $box.on('click', '.block-toggle-header', function(event) {
        var $content = $box.find('.block-toggle-content');

        $box.toggleClass('is-active');

        if ( $box.hasClass('is-active') ) {
          $content.slideDown();
          $box.attr('aria-expanded', 'true');
        } else {
          $content.slideUp();
          $box.attr('aria-expanded', 'false');
        }
      });
    });



    // Modul: Ticker
    var $ticker = $('.ticker');
    if ( $ticker.length > 0 ) {
      var itemWidth = $ticker.find('.ticker-text').outerWidth();
      var duration = $ticker.find('.ticker-text').text().length/10 + 's'; /* calculate speed based on text length */

      $ticker.find('.ticker-container').css('animation-duration', duration);
      $ticker.addClass('play');
    }

    // Modul: Scrollbar
    $('.has-scrollbars').each(function() {
      if ( $('body').width() <= breakpoint ) return; /* skip on mobile */

      $(this).height(bodyHeight - headerOffset - tickerHeight); /* Chrome needs absolute height */
      new SimpleBar(this);
    });


    $('.programm-item').on('click', '.link-video', function(event) {
      var $this = $(this);
      
      if ( !$this.hasClass('is-zoom') ) {
        console.log('is not zoom');
        $('.link-video').removeClass('is-active');  //remove from all 
        $this.addClass('is-active');
        return;
      }

      console.log('hello video');    
    });


    $('.programm-item').on('click', '.link-video.is-video, .link-video.is-zoom-api, .link-video.is-padlet', function(event) {
      event.preventDefault();
      var $this = $(this);
      var $video = $('.video');

      // var ytid = $this.data('ytid');
      // var vmid = $this.data('vmid');
      // var zmid = $this.data('zmid');
      // var zmid = $this.data('zmpwd');

      // if ( $('body').width() <= breakpoint && !$this.hasClass('is-zoom')) {
      //     $('html, body').animate({
      //         scrollTop: $video.offset().top - headerHeight
      //     }, 800);
      // }

      $('.video-play.zoom-api .zoom-info', $video).remove(); // Zoom API: Link

      
      $video.removeClass('is-playing');

      // if ($this.hasClass('is-youtube') )
      //     $video
      //         .attr('data-ytid', ytid)
      //         .attr('data-vmid', '');
      
      
      // if ($this.hasClass('is-vimeo') )
      //     $video
      //       .attr('data-vmid', vmid)
      //       .attr('data-ytid', '');
      
    });

    // $('.video').on('click', '.close', function(event) {
    //   if ( $('body').width() <= breakpoint ) 
    //     $('html, body').css('overflow-y', 'scroll');
      
    //   $(this).closest('.is-playing').removeClass('is-playing');
    //   $('.video').removeClass('is-active'); /* remove from all */
    //   $('.link-video').removeClass('is-active');
    //   $(this).hide();
    // });

    // Programm: Text
    $('.programm-item').on('click', '.link-text', function(event) {
      event.preventDefault();
      var $this = $(this);
      var $text = $('.text');

      if ( $('body').width() <= breakpoint ) {
        jQuery('.programm-item .programm-content-wrap.ghost')
          .hide();

        $this
          .closest('.programm-item')
          .find('.programm-content-wrap.ghost')
          .fadeIn()
          // .show()
          .addClass('is-active')
          ;

        $this
          .closest('.programm-item')
          .find('.programm-content-wrap.ghost .button.trigger-close')
          .show();


          $('html, body').animate({
            scrollTop: $this.closest('.programm-item').offset().top
          }, 800);  
      }

      $('.link-text').removeClass('is-active'); /* remove from all */
      $this.addClass('is-active');


      $('.text').removeClass('is-active'); /* remove from all */
      $text.css('top', headerOffset).addClass('is-active');
    });

    $('.programm-item').on('click', '.trigger-close', function(event) {
      event.preventDefault();
      var $this = $(this);

      $this
          .closest('.programm-content-wrap.ghost')
          .slideUp()
          ;

      $('html, body').animate({
            scrollTop: $this.closest('.programm-item').offset().top
          }, 800); 
      });

    /* trigger first items on tablet up viewports */
    if ( $('body').width() > breakpoint ) {
      $('.programm-item:first').find('.link-text').trigger('click');
    }
      $('.programm-item:first').find('.link-video:first').trigger('click');

  });
})(jQuery)
